/* global axios */
import ApiClient from './ApiClient';

class WhatsAppStickerAPI extends ApiClient {
  constructor() {
    super('whatsapp_stickers', { accountScoped: true });
  }

  create(file) {
    const payload = new FormData();
    payload.append('file', file);

    return axios.post(this.url, payload);
  }

  createFromAttachment(attachmentId) {
    return axios.post(`${this.url}/from_attachment`, {
      attachment_id: attachmentId,
    });
  }
}

export default new WhatsAppStickerAPI();
